
import { Component, Vue } from 'vue-property-decorator'

/**
 * Vueメイン部品
 */
@Component
export default class App extends Vue {
  /**
   * インスタンス生成時処理
   */
  public created(): void {
    const router = this.$router

    history.pushState(null, '', location.href)
    // ブラウザバックを制御する
    window.addEventListener('popstate', () => {
      // 履歴に現在ページのパスを追加し、リロードを抑制
      history.pushState(null, '', router.currentRoute.fullPath)
      router.go(1)
    })
  }
}
